const FinancialReports = () =>
    import("./index.vue");
const IncomeStatement = () =>
    import("./income-statement.vue");
const BalanceSheet = () =>
    import("./balance-sheet.vue");
const TrialBalance = () =>
    import("./trial-balance.vue");
const JournalReport = () =>
    import("./journal-entries.vue");
const AccountsAudit = () =>
    import("./accounts-audit.vue");

export default [
    {
        path: "/financial-reports",
        component: FinancialReports,
    },
    {
        path: "/accounts/audit",
        component: AccountsAudit,
    },
    {
        path: "/income-statement",
        component: IncomeStatement,
    },
    {
        path: "/balance-sheet",
        component: BalanceSheet,
    },
    {
        path: "/trial-balance",
        component: TrialBalance,
    },
    {
        path: "/journal-entries-report",
        component: JournalReport,
    },
];
